export const themes = {
    blankThemeProps: {
        '--header-color': '#FFFFFF',
        '--accent-color': '#56238E',
        '--text-color': '#000000',
        '--text-hover-color': '#FFFFFF',
        '--breadcrumbs-color': '#8AC5EF',
        '--breadcrumbs-text-color': '#000000',
        '--top-header-bg': '#FFFFFF',
        '--top-header-text-color': '#000000',
        '--top-border-bottom': 'none',
        '--top-header-img-logo-bg': '#eee'
    },
    purpleThemeProps: {
        '--header-color': '#8f47c9',
        '--accent-color': '#56238E',
        '--text-color': '#FFFFFF',
        '--text-hover-color': '#FFFFFF',
        '--breadcrumbs-color': '#8861B2',
        '--breadcrumbs-text-color': '#ffffff',
        '--top-header-bg': '#56238E',
        '--top-header-text-color': '#FFFFFF',
        '--top-border-bottom': 'none',
        '--top-header-img-logo-bg': '#eee'
    },
    blueThemeProps: {
        '--header-color': '#367b99',
        '--accent-color': '#3899DD',
        '--text-color': '#FFFFFF',
        '--text-hover-color': '#FFFFFF',
        '--breadcrumbs-color': '#8AC5EF',
        '--breadcrumbs-text-color': '#0767AB',
        '--top-header-bg': '#3899DD',
        '--top-header-text-color': '#FFFFFF',
        '--top-border-bottom': 'none',
        '--top-header-img-logo-bg': '#eee'
    },
    alphaBlueThemeProps: {
        '--header-color': '#3899dd',
        '--accent-color': '#3899DD',
        '--text-color': '#FFFFFF',
        '--text-hover-color': '#FFFFFF',
        '--breadcrumbs-color': '#8AC5EF',
        '--breadcrumbs-text-color': '#0767AB',
        '--top-header-bg': '#3899DD',
        '--top-header-text-color': '#FFFFFF',
        '--top-border-bottom': 'none',
        '--top-header-img-logo-bg': '#eee'
    },
    greenThemeProps: {
        '--header-color': '#208f1e',
        '--accent-color': '#86BC35',
        '--text-color': '#FFFFFF',
        '--text-hover-color': '#FFFFFF',
        '--breadcrumbs-color': '#C6EE89',
        '--breadcrumbs-text-color': '#4B7A04',
        '--top-header-bg': '#86BC35',
        '--top-header-text-color': '#FFFFFF',
        '--top-border-bottom': 'none',
        '--top-header-img-logo-bg': '#eee'
    },
    grayThemeProps: {
        '--header-color': '#717370',
        '--accent-color': '#86BC35',
        '--text-color': '#FFFFFF',
        '--text-hover-color': '#FFFFFF',
        '--breadcrumbs-color': '#C6EE89',
        '--breadcrumbs-text-color': '#4B7A04',
        '--top-header-bg': '#86BC35',
        '--top-header-text-color': '#FFFFFF',
        '--top-border-bottom': 'none',
        '--top-header-img-logo-bg': '#eee'
    }
};